/**
 * Validate hours for expired catchup content
 *
 * @return {Boolean}
 */
export const checkExpiredCatchUpContent = (hours, endDateEvent) => {
  if ((hours && hours) < 0 || !endDateEvent) return true;

  const endDate = new Date(endDateEvent);
  const now = new Date();

  const millisecondDifferences = now - endDate;
  const hoursToMilliseconds = hours * 60 * 60 * 1000;

  return millisecondDifferences <= hoursToMilliseconds;
};
